import Wrapper from '@/components/shared/Wrapper';
import { StyledProp, styled } from '@/styled';

import CarouselOffers from './CarouselOffers';
import Invites from './Shelves/Invites';
import KeepLearningShelf from './Shelves/KeepLearning';
import ModulesShelf from './Shelves/Modules';
import MyCourses from './Shelves/MyCourses';
import RecentlySavedShelf from './Shelves/RecentlySaved';

const Showcase: React.FC = (props: StyledProp) => {
  return (
    <>
      <CarouselOffers />
      <Wrapper {...props}>
        <KeepLearningShelf />
        <RecentlySavedShelf />
        <Invites />
        <MyCourses />
        <ModulesShelf />
      </Wrapper>
    </>
  );
};

export default styled(Showcase)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.spacing(16)};
`;
